import { AUTHENTICATED_ENTRY } from '../../configs/AppConfig';

export const getFirstNavigation = (permission) => {
  if (!Array.isArray(permission)) {
    return AUTHENTICATED_ENTRY;
  }
  if (permission?.length) {
    let sortedMenu = permission.sort((a, b) => a.order - b.order);

    return sortedMenu?.[0]?.path;
  }
  return AUTHENTICATED_ENTRY;
};
